import type { ComponentProps } from 'react';
import { cn } from '~/utils/cn';

export function LandingSectionHeader({
  className,
  ...restProps
}: ComponentProps<'h1'>) {
  return (
    <h2
      className={cn(
        'text-2xl font-bold max-w-[580px]',
        'lg:text-4xl',
        className,
      )}
      {...restProps}
    />
  );
}
